import { useRefGetter } from '../../use';
import { useEffect, useRef } from 'react';
import { addEventListener, isClient, removeEventListener } from '../../co-dom';
export function useDocumentClick(enable, onClick) {
  var onDocClickGetter = useRefGetter(onClick);
  var initRef = useRef(false);
  var enableGetter = useRefGetter(enable);
  useEffect(function () {
    if (!enableGetter()()) {
      return;
    }

    initRef.current = true;

    var callback = function callback(e) {
      if (!enableGetter()()) {
        return;
      }

      onDocClickGetter()(e);
    };

    if (isClient()) {
      addEventListener(document, 'click', callback, false);
      return function () {
        return removeEventListener(document, 'click', callback);
      };
    }
  }, [initRef.current, enableGetter()()]);
}